/// <amd-module name="Artifacts/Package/services/ProvenanceDataService" />
import { PackageVersionProvenance } from "Artifacts/Root/web-apis/contracts/Feed";
import { getFeedClient, IFeedRestClient } from "Artifacts/Root/web-apis/RestClient/Feed";
import { IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IFeedProvenanceDataService extends IVssService {
  getPackageVersionProvenance(
    projectId: string | undefined,
    feedId: string,
    packageId: string,
    versionId: string,
  ): Promise<PackageVersionProvenance>;
}

export class ProvenanceDataService extends VssService implements IFeedProvenanceDataService {
  public async getPackageVersionProvenance(
    projectId: string | undefined,
    feedId: string,
    packageId: string,
    versionId: string,
  ): Promise<PackageVersionProvenance> {
    return this.FeedRestClient.getPackageVersionProvenance(feedId, packageId, versionId, projectId);
  }

  private get FeedRestClient(): IFeedRestClient {
    return getFeedClient(this.pageContext);
  }
}

Services.add("IFeedProvenanceDataService", { serviceFactory: ProvenanceDataService });
